import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { generateDispatchToPropsMap, SofaButton, SofaPopup } from '@sofology/sofologycomponents';

import './InvalidItemsModal.scss';

import { removeInvalidItems, RemoveInvalidItemsFunc, setShowInvalidItemsRemovingWarning, SetShowInvalidItemsRemovingWarningFunc } from 'store/basket/actions';
import { AppState } from 'store';
import { BasketItemModel, BasketValidationResultModel } from 'models/Basket';

interface OwnProps {
    isBasketPage?: boolean;
}

interface StateProps {
    shouldShowInvalidItemsRemovingWarning: boolean;
    validationResult: BasketValidationResultModel;
}

interface DispatchProps {
    removeInvalidItems: RemoveInvalidItemsFunc;
    setShowInvalidItemsRemovingWarning: SetShowInvalidItemsRemovingWarningFunc;
}

const SOFASHIELD_IMAGE_URL = 'https://images.sofology.co.uk/b_rgb:fff,c_pad,q_100,fl_lossy,f_auto,h_150/Sofashield/sofashield_nsuhdh_1.png';

class InvalidItemsModal extends Component<OwnProps & StateProps & DispatchProps> {
    handleRemoveInvalidItemsClick = () => {
        this.props.setShowInvalidItemsRemovingWarning(false);
        this.props.removeInvalidItems(this.props.isBasketPage);
    };

    render(): JSX.Element {
        const { shouldShowInvalidItemsRemovingWarning, validationResult } = this.props;

        const hasSofashield = validationResult.sofaShields.length > 0;
        const hasNonSofashield = validationResult.invalidItems.length > 0;

        return (
            <SofaPopup open={shouldShowInvalidItemsRemovingWarning} message=''>
                <div className='invalid-items-removing-modal'>
                    {hasNonSofashield && this.renderInvalidItems(validationResult.invalidItems)}

                    {hasSofashield && this.renderSofaShield()}

                    <div className='invalid-items-removing-modal__button-container'>
                        <SofaButton variant='secondary' onClick={this.handleRemoveInvalidItemsClick} text='OK' />
                    </div>
                </div>
            </SofaPopup>
        );
    }

    renderSofaShield = (): JSX.Element => {
        return (
            <div className='invalid-items-removing-modal__sofashield-section'>
                <div className='invalid-items-removing-modal__image-container'>
                    <img src={SOFASHIELD_IMAGE_URL} alt='Sofashield Plus protection' />
                </div>
                <div className='invalid-items-removing-modal__text-container'>
                    <p className='title'>Unfortunately Sofashield Plus is currently unavailable in Eire</p>
                    <p className='description'>The price of Sofashield Plus cover will be removed from your order and deducted from the final price.</p>
                </div>
            </div>
        );
    };

    renderInvalidItems = (nonSofashieldItems: BasketItemModel[]): JSX.Element => {
        const isPlural = nonSofashieldItems.length > 1;

        return (
            <div className='invalid-items-removing-modal__invalid-items-section'>
                <div className='invalid-items-removing-modal__text-container'>
                    <p className='title'>
                        We're sorry,{isPlural ? ' some items' : ' an item'} in your basket cannot be delivered to a Northern Ireland/ROI address due to regulatory restrictions.
                    </p>
                    <p className='title'>
                        The following product{isPlural ? 's are' : ' is'} affected:
                    </p>
                    <ul className='invalid-items-removing-modal__invalid-items-list'>
                        {nonSofashieldItems.map((item: BasketItemModel) => (
                            <li className='invalid-items-removing-modal__invalid-item' key={`${item.product.range}-${item.product.webDescription}`}>
                                {item.product.range} {item.product.webDescription}
                            </li>
                        ))}
                    </ul>
                    <p className='description'>
                        {isPlural ? 'These' : 'This'} product{isPlural ? 's will' : ' will'} be removed from basket.
                    </p>
                </div>
            </div>
        );
    };
}

function mapStateToProps(state: AppState): StateProps {
    return {
        shouldShowInvalidItemsRemovingWarning: state.basketState.shouldShowInvalidItemsRemovingWarning,
        validationResult: state.basketState.validationResult
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [removeInvalidItems, setShowInvalidItemsRemovingWarning]);
}

export default connect(mapStateToProps, mapDispatchToProps)(InvalidItemsModal);
